import React, { useState } from "react";
import "./InternalTransfer.css";
import { supabase } from "../supabaseClient";
import { Send, CheckCircle, Plus, Minus } from "lucide-react";

export default function InternalTransfer() {
  const [amount, setAmount] = useState("");
  const [traderId, setTraderId] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [activeFaq, setActiveFaq] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  const handleTransfer = async () => {
    if (loading) return;

    const cleanAmount = parseFloat(amount);
    const cleanTraderId = traderId.trim();

    if (!cleanAmount || cleanAmount <= 0) {
      setErrorMsg("Please enter a valid amount");
      return;
    }

    if (!cleanTraderId) {
      setErrorMsg("Receiver Trader ID is required");
      return;
    }

    setErrorMsg("");
    setLoading(true);
    setSuccess(null);

    try {
      const { data, error } = await supabase.rpc("internal_transfer", {
        receiver_trader_id: cleanTraderId,
        transfer_amount: cleanAmount,
      });

      if (error) {
        setErrorMsg(error.message);
      } else {
        setSuccess(data);
        setAmount("");
        setTraderId("");
      }
    } catch (err) {
      setErrorMsg("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const faqs = [
    {
      q: "What is Internal Transfer?",
      a: "Internal Transfer allows you to send funds instantly to another user within the platform without any blockchain fees or delays.",
    },
    {
      q: "How do I send funds to another user?",
      a: "Enter the receiver's Trader ID, input the amount, and click Send Funds. The transfer is processed instantly.",
    },
    {
      q: "Where can I find my Receiving Trader ID?",
      a: "Your Trader ID is available in the Profile or Wallet section. Share this ID to receive internal transfers.",
    },
    {
      q: "Is internal transfer instant?",
      a: "Yes, all internal transfers are real-time and balances are updated instantly.",
    },
  ];

  return (
    <div className="internal-transfer-wrapper">
      <div className="transfer-card">
        {!success ? (
          <>
            <h2 className="transfer-title">Internal Transfer</h2>
            <p className="transfer-sub">
              Send funds instantly to another trader
            </p>

            <div className="form-group">
              <label>Amount</label>
              <input
                type="number"
                placeholder="Enter amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label>Receiver Trader ID</label>
              <input
                type="text"
                placeholder="TRD-XXXXXXXXXX"
                value={traderId}
                onChange={(e) => setTraderId(e.target.value)}
                disabled={loading}
              />
            </div>

            {errorMsg && (
              <div className="transfer-error">
                {errorMsg}
              </div>
            )}

            <button
              className={`send-btn ${loading ? "loading" : ""}`}
              onClick={handleTransfer}
              disabled={loading}
            >
              {loading ? (
                <span className="spinner"></span>
              ) : (
                <>
                  <Send size={18} />
                  Send Funds
                </>
              )}
            </button>

            {/* FAQ SECTION */}
            <div className="transfer-faq">
              <h3>Internal Transfer Guide</h3>

              {faqs.map((item, index) => (
                <div
                  key={index}
                  className={`faq-item ${
                    activeFaq === index ? "open" : ""
                  }`}
                >
                  <div
                    className="faq-question"
                    onClick={() =>
                      setActiveFaq(activeFaq === index ? null : index)
                    }
                  >
                    <span>{item.q}</span>
                    {activeFaq === index ? <Minus /> : <Plus />}
                  </div>

                  <div className="faq-answer">
                    {item.a}
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="success-box">
            <CheckCircle size={64} className="success-icon" />
            <h3>Transfer Successful</h3>
            <p>
              Amount: <b>{success.amount}</b>
            </p>
            <p>
              To: <b>{success.to}</b>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
